{
  "addKey": "Add key",
  "api": {
    "anthropic": "Anthropic",
    "gemini": "Gemini (billed Cloud project only)",
    "openai": "OpenAI",
    "openai_compatible": "OpenAI-compatible (such as KISSKI)"
  },
  "apiKey": "API key",
  "baseUrl": "Base URL",
  "budgetCalls": "Calls",
  "budgetHelp": "Per calendar month (UTC), counted by DMW. Leave a field empty for no limit. The provider's own limits apply as well.",
  "budgetTokens": "Tokens",
  "callsOfLimit_one": "{{used}} of {{count}} call",
  "callsOfLimit_other": "{{used}} of {{count}} calls",
  "callsUsed_one": "{{count}} call",
  "callsUsed_other": "{{count}} calls",
  "changeBudget": "Change budget",
  "geminiBilledOnly": "Use a key of a Cloud project with billing. Free-tier keys may not serve other people; they belong in a person's own DMW Connector.",
  "hostOffline": "DMW server offline",
  "hostOnline": "DMW server online",
  "hostsHint": "Approve a group in Administration → Installation, then allow it in Project settings → Rules.",
  "hostsTitle": "DMW servers",
  "intro": "Keys are encrypted and shown only when you enter them.",
  "keyDetails": "…{{hint}} · {{models}} · added {{time}}",
  "keyHelp": "The server checks the key with the provider before storing it. Revoking a key here does not revoke it at the provider.",
  "keysTitle": "Keys",
  "llmCount_one": "{{count}} LLM",
  "llmCount_other": "{{count}} LLMs",
  "noHosts": "No one may use the server's keys yet.",
  "noKeys": "No keys yet.",
  "offBody": "Server keys are off: {{reason}}. An operator sets the key-encryption key file and the GTA command in the server's configuration.",
  "offTitle": "Server keys are off",
  "pairedAt": "since {{time}}",
  "provider": "Provider",
  "removedAccount": "Removed account",
  "revokeKey": "Revoke",
  "revokeKeyConfirm": "Revoke this key? Its stored copy is deleted at once. Revoke it at the provider too.",
  "revoked": "Revoked",
  "routeName": "Route name",
  "routeNameHelp": "Enter a name, such as Anthropic Server. Spaces become hyphens.",
  "routeNameInvalid": "Use a name that starts with a letter (A–Z) or digit (0–9).",
  "routeNameSavedAs": "Saved as: {{routeId}}",
  "saveBudget": "Save budget",
  "spend": {
    "limit": "Monthly limit: {{amount}}",
    "limitNotRead": "Limit not read: {{reason}}",
    "limitStated": "Monthly limit: {{amount}} (as set in the provider's console)",
    "noLimit": "No monthly limit known",
    "none": "Not set up. To see the providers' own spend and limits here, give the server an admin key file (Help: Server keys).",
    "notRead": "Spend not read: {{reason}}",
    "organization": "organization",
    "readAt": "read {{time}}",
    "spent": "{{month}}: {{amount}} spent",
    "title": "Spend at the providers"
  },
  "title": "Server keys",
  "tokensOfLimit_one": "{{used}} of {{count}} token",
  "tokensOfLimit_other": "{{used}} of {{count}} tokens",
  "tokensUsed_one": "{{count}} token",
  "tokensUsed_other": "{{count}} tokens",
  "usage": "{{period}}: {{calls}}, {{tokens}}"
}
